import{a as e}from"./chunk-EI7MMDWY.js";var c=e(r=>(Array.isArray(r)||(r=Object.values(r)),r.reduce((u,a)=>u+a,0)),"sum");export{c as a};
